
import { useCallback } from "react";
import { toast } from "sonner";
import { signUp as authSignUp, signIn as authSignIn, signOut as authSignOut } from "../authHelpers";

export const useAuthActions = () => {
  const signUp = useCallback(async (email: string, password: string, profileData?: { display_username: string; university_id: string; lab_id: string }) => {
    try {
      await authSignUp(email, password, profileData);
      // Don't redirect immediately - let the RegisterPage handle the success state
    } catch (error) {
      console.error("Sign up error in useAuthActions:", error);
      toast.error("Registration failed: " + (error instanceof Error ? error.message : "Unknown error"));
    }
  }, []);

  const signIn = useCallback(async (email: string, password: string) => {
    try {
      await authSignIn(email, password);
      // Instead of using navigate directly, we'll redirect using window.location
      window.location.href = "/dashboard";
    } catch (error) {
      console.error("Sign in error in useAuthActions:", error);
      toast.error("Login failed: " + (error instanceof Error ? error.message : "Unknown error"));
    }
  }, []);

  const signOut = useCallback(async () => {
    try {
      console.log("useAuthActions: signOut called");
      await authSignOut();
      // Navigation is handled in the authSignOut function
    } catch (error) {
      console.error("Sign out error in useAuthActions:", error);
      toast.error("Logout failed: " + (error instanceof Error ? error.message : "Unknown error"));
    }
  }, []);

  return {
    signUp,
    signIn,
    signOut
  };
};
